<template>
  <div class="content">
    <!-- 编辑蒙版 -->
    <el-dialog title=""
               :visible.sync="editAdd"
               width="1190px"
               :before-close="handleClose">
      <!--  :before-close="handleClose2" -->
      <div class="addArea"
           v-if="addressInfo">
        <h2 class="addTitle">编辑收货地址</h2>
        <div class="addInfo">
          <div class="addInfo1 addli">
            <p>* 地址信息</p>
            <el-select :placeholder="addressInfo.province"
                       @change="handleProvinceChoose"
                       v-model="selectProvince"
                       style="margin-right: 20px;">
              <el-option v-for="(item, index) in provinceList"
                         :key="index"
                         :label="item.name"
                         :value="`${item.name}%${item.codeP}`">
              </el-option>
            </el-select>
            <el-select :disabled="selectProvince?false:true"
                       v-model="selectCity"
                       :placeholder="addressInfo.city"
                       @change="handleCityChoose"
                       style="margin-right: 20px;">
              <el-option v-for="(item, index) in cityList"
                         :key="index"
                         :label="item.name"
                         :value="`${item.name}%${item.codeC}`">
              </el-option>
            </el-select>
            <el-select :disabled="selectCity?false:true"
                       v-model="selectArea"
                       :placeholder="addressInfo.area"
                       @change="handleAreaChoose">
              <el-option v-for="(item, index) in areaList"
                         :key="index"
                         :label="item.name"
                         :value="`${item.name}%${item.codeA}`">
              </el-option>
            </el-select>
          </div>
          <div class="addInfo2 addli">
            <p>* 详细地址</p>
            <input v-model.trim="addressInfo.reciveAddress"
                   type="text"
                   placeholder="请输入详细地址信息">
          </div>
          <div class="addInfo3 addli">
            <p>* 收货人姓名</p>
            <input v-model.trim="addressInfo.reciveName"
                   type="text"
                   placeholder="请输入收货人姓名">
          </div>
          <div class="addInfo4 addli">
            <p>* 手机号码</p>
            <input v-model.number="addressInfo.recivePhone"
                   type="text"
                   placeholder="请输入手机号码">
            <div style="width: 516px"></div>
            <el-checkbox v-model="addressInfo.defaulted"
                         text-color="#333333"
                         fill="#1D65A8"
                         class="defaultbox">
              设为默认收货地址
            </el-checkbox>
          </div>
        </div>
        <div @click="handleSaved()"
             class="saveAdd">保存地址</div>
      </div>
    </el-dialog>
    <div class="page-title">支付结算</div>
    <div class="address-list">
      <div :class="(selectAddId === item.id ?'address addressSelect': 'address') + (index%4 !== 0? ' address-margin-left': '')"
           v-for="(item, index) in addressList"
           :key="item.id"
           @click="chooseAddress(item.id)">
        <div class="consignee-name overell">{{item.receiveGoodsPerson}}</div>
        <div class="consignee-add">{{item.province}}{{item.city}}{{item.area}}{{item.address}}</div>
        <el-button type="text"
                   class="addUpdate-button"
                   @click.stop="addUpadateAddHandle(item)">修改</el-button>
      </div>
    </div>
    <button class="button shop-cart-but"
            @click.stop="addUpadateAddHandle()">使用新地址</button>
    <el-table :data="goodsList"
              border
              style="margin-top:40px;">
      <el-table-column prop="goodsName"
                       header-align="center"
                       align="center"
                       label="商品图片">
        <template slot-scope="scope">
          <div style="display:flex;">
            <div><img width="146"
                   height="80"
                   :src="scope.row.goodsUrl||'/static/img/bitmap.png'" /></div>
            <div class="good-name">{{scope.row.goodsName}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="goodsCategory"
                       header-align="center"
                       align="center"
                       label="类别">
        <template slot-scope="scope">
          <span v-if="scope.row.goodsCategory === 'course'">课程</span>
          <span v-else-if="scope.row.goodsCategory === 'realdoc'">实体书</span>
          <span v-else-if="scope.row.goodsCategory === 'doc'">电子书</span>
          <span v-else-if="scope.row.goodsCategory === 'cert'">证书</span>
        </template>
      </el-table-column>
      <el-table-column prop="currentPrice"
                       header-align="center"
                       align="center"
                       label="价格"
                       width="100px"></el-table-column>
      <el-table-column prop="num"
                       header-align="center"
                       align="center"
                       label="数量">
        <template slot-scope="scope">{{scope.row.num || 1}}</template>
      </el-table-column>
    </el-table>
    <div class="coupon-row">
      <div v-if="type!==5">
        优惠券：
        <el-select v-model="couponType"
                   placeholder="请选择"
                   style="width:200px;"
                   @change="changeCouponType">
          <el-option label="优惠券"
                     :value="1"></el-option>
          <el-option label="优惠码"
                     :value="2"></el-option>
        </el-select>
      </div>
      <div v-if="type!==5">
        优惠内容：
        <el-select v-model="couponId"
                   placeholder="请选择"
                   v-if="couponType===1"
                   style="width:200px;">
          <el-option v-for="item in couponList"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="couponId"
                  placeholder="请输入优惠码"
                  v-if="couponType===2"
                  style="width:200px;"></el-input>
      </div>
      <div>
        使用余额：
        <el-input v-model="usedBalance"
                  placeholder="请输入余额"
                  style="width:200px;"></el-input>
      </div>
    </div>
    <div class="money-row">
      <div v-if="couponMoney">
        优惠码金额：<div class="money-used">￥{{couponMoney}}</div>
      </div>
      <div>
        可用金额：<div class="money-used">￥{{userBalance}}</div>
      </div>
      <div>
        总价：<div class="money-used final-money">￥{{actualPrice}}</div>
      </div>
    </div>
    <div class="pay-row">
      <button class="button pay-button"
              @click="createOrder()">支付</button>
      <!-- <button class="button pay-button" @click="submitPay()">支付</button> -->
    </div>
    <!-- <form name="punchout_form" method="post" action="https://openapi.alipaydev.com/gateway.do?charset=UTF-8&method=alipay.trade.page.pay&sign=RxcAkFTGbFfxOFCmpMe%2FAi3gaXY%2FdJa2CvdlIQup1%2BoScB9IDjlO46G0OGoPw9azlZoulSnYEnnBULmLjYLtF1ju35U8qDQEkXSkGB%2FJp50sBBZTtkK1jd2t9t2ljzW75YVfHjnmejKq01NqTLyIFSN3bw%2Bp9qSVgtxTznvji5foGWQeSl6S%2FVKB5fhcz6UE3Jk5jTKH6T9HCqFG7UZOYpgR37dMT9qBap6P7Xs8VzXu1P%2BJGwfptI94SHIS8A7%2FnblAB1mv98V8nIVO7T1LVgbab8Fe85MUmID8W1D%2FPLtNUatr0WFYs4xoz1s1J99khIRrpdkzkCsbpzWQ0QMMDw%3D%3D&return_url=http%3A%2F%2Fwww.jc9.top%2FalipayReturnNotice&notify_url=http%3A%2F%2Fwww.jc9.top%2FalipayNotifyNotice&version=1.0&app_id=2016091900545054&sign_type=RSA2&timestamp=2020-02-22+15%3A46%3A01&alipay_sdk=alipay-sdk-java-3.3.0&format=json"> -->
    <!-- <form name="punchout_form" method="post" action="https://openapi.alipay.com/gateway.do?charset=UTF-8&method=alipay.trade.page.pay&sign=duDBzZKAIx7FHAbQMa9mc%2Fz0KusVgUYSt1Ulzgedjtupo9gI4LM%2B%2BWjaFPPX2MVv%2BC9GsqwtaOh8i01hVajOzLV1w0spAYKeGEw0GCNA87D7YC6rqA1GL6ZZRUHueF8e9kS1JoVxmITUi6e1SQmFGEJpITBbEqZ82asi3tShwXpC4mQ%2BjrKnCHtj4WAh59%2FMiU1sh1AI9NbjDbGjOI3rGMbAGU8uu%2BMKly17fVAVAKEU92XUV6ftGvTuVbe52X8tiOmZE39PFwWR%2FSzAd%2FOIE31kiMrAOhIgA9mhR5w4EQKgHd8Aknl2USFSDmpy%2FmRaVXH5ft18zqgvuXVBdmoblA%3D%3D&return_url=https%3A%2F%2Fi-learning.supcon.com%2FalipayReturnNotice&notify_url=https%3A%2F%2Fi-learning.supcon.com%2FalipayNotifyNotice&version=1.0&app_id=2018080960984604&sign_type=RSA2&timestamp=2020-02-22+15%3A05%3A23&alipay_sdk=alipay-sdk-java-dynamicVersionNo&format=json"> -->
    <!-- <input type="hidden" name="biz_content" value="{&quot;body&quot;:&quot;用户订购商品个数：1&quot;,&quot;out_trade_no&quot;:&quot;fcb6c0efa1f64a11a80f&quot;,&quot;product_code&quot;:&quot;QUICK_WAP_WAY&quot;,&quot;subject&quot;:&quot;32购买fcb6c0efa1f64a11a80f&quot;,&quot;timeout_express&quot;:&quot;1m&quot;,&quot;total_amount&quot;:&quot;100.00&quot;}"> -->
    <!-- <input type="submit" value="立即支付" style="display:none" > -->
    <!-- </form> -->
  </div>
</template>
<script>
// import {openOther} from '@/utils'
export default {
  data () {
    return {
      isCart: false,
      totalPrice: 0,
      count: 0,
      userBalance: 0, // 可用余额
      inviteUser: '', // 邀请人ID
      couponList: [],
      addressList: [],
      goodsList: [],
      // actualPrice: 0,
      usedBalance: 0, // 使用余额
      couponType: '', // 优惠类型
      couponId: '', // 优惠券的ID 或者优惠码
      couponMoney: '', // 优惠码的
      selectAddId: 0,
      editAdd: false, // 编辑地址
      addressInfo: null,
      provinceList: [],
      cityList: null,
      areaList: null,
      selectProvince: '',
      selectCity: '',
      selectArea: '',
      codeP: '',
      codeC: '',
      codeA: ''
    }
  },
  created () {
    this.getAddressList()
  },
  mounted () {
    this.getInfo()
  },
  computed: {
    actualPrice () {
      let actualPrice = this.totalPrice
      if (this.couponType === 1 && this.couponId) {
        let index = this.couponList.findIndex(item => {
          return item.id === this.couponId
        })
        if (index > -1) {
          actualPrice = Math.round((actualPrice - this.couponList[index].amount) * 100) / 100
        }
      } else if (this.couponType === 2 && this.couponMoney) {
        actualPrice = actualPrice - this.couponMoney
      }
      if (actualPrice < 0) {
        actualPrice = 0
        if ((Number(this.usedBalance) || 0) > 0) {
          this.$message.warning('请调整输入可用金额,优惠券已满足')
        }
      } else {
        actualPrice = actualPrice - Number(this.usedBalance)
        if (actualPrice < 0) {
          actualPrice = 0
          this.$message.warning('请调整输入可用金额,减少使用余额')
        }
      }
      // 有关优惠券处理
      // actualPrice = actualPrice - Number(this.usedBalance)
      // if (actualPrice < 0) {
      //   this.$message.error('请调整输入可用金额')
      // }
      // couponMoney
      // console.log(this.$route.query.ids)
      // let goodIds = this.$route.query.ids
      actualPrice = Math.round(actualPrice * 100) / 100
      return actualPrice
    },
    productId () {
      return this.$route.query.goodsId
    },
    type () {
      return Number(this.$route.query.type)
    }
  },
  watch: {
    productId (val) {
      if (val) {
        this.getInfo()
        this.getAddressList()
      }
    },
    couponId (val) {
      this.couponMoney = 0
      if (this.couponType === 2 && val.length === 17) {
        this.searchCouponCode(val)
      }
    }
    // usedBalance (val) {
    //   if (val && ((Number(val) || 0) > this.userBalance)) {
    //     console.log(2)
    //     this.$message.warning('请输入小于可用金额的使用余额')
    //   }
    // }
  },
  methods: {
    getInfo () {
      this.totalPrice = 0
      this.count = 0
      this.userBalance = 0
      this.inviteUser = ''
      this.couponList = []
      // this.addressList = []
      this.goodsList = []
      this.$http.post(`/front/train/trainShoppingCart/settlementDataSelect`, {
        'productId': this.productId, // 购物车类型产品id不传
        'type': this.type, // 立即购买商品类型 1、课程；2、电子书；3、购物车；4、实体书；5、证书
        'count': this.type !== 3 ? 1 : '', // 购买数量  除购物车类型，其他必填
        'inviteUser': '' // 选填
      }).then((data) => {
        if (data.data.code === 0) {
          this.totalPrice = data.data.data.totalPrice
          // this.actualPrice = data.data.data.totalPrice
          this.count = data.data.data.count
          this.userBalance = data.data.data.userBalance
          this.inviteUser = data.data.data.inviteUser
          this.couponList = data.data.data.couponList
          this.goodsList = data.data.data.goodsList || []
          // this.addressList = data.data.data.addressList
        } else {
          this.$message.error(data.data.msg)
        }
        // console.log(data)
      })
    },
    // 查询优惠码的优惠金额
    searchCouponCode (val) {
      this.$http.get(`${window.SITE_CONFIG['trainURL']}/discountCode/traindiscountcodedetail/info/${val}`)
        .then(data => {
          if (data.data.code === 0) {
            if (data.data.data.used === false) {
              this.couponMoney = data.data.data.amount || 0
            }
          }
        })
    },
    // 选中地址
    chooseAddress (id) {
      this.selectAddId = id
    },
    getAddressList () {
      this.addressList = []
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/integral/userorderaddress/selectOrderAddress`)
        .then(data => {
          if (data.data.code === 0) {
            this.addressList = data.data.data
            let temp = []
            if (this.selectAddId) {
              temp = this.addressList.filter(item => {
                return item.id === this.selectAddId
              })
            }
            if (temp.length === 0) {
              temp = this.addressList.filter(item => {
                return item.defaultAddress === true
              })
            }
            this.selectAddId = temp.length ? temp[0].id : ''
          } else {
            this.$message.error(data.data.msg || '获取地址失败')
          }
        })
        .catch(() => {
          this.$message.error('获取地址失败')
        })
    },
    // 修改编辑地址
    addUpadateAddHandle (item) {
      this.getProvince()
      // console.log(item)
      if (item) {
        // this.addressInfo = item
        this.selectCity = ''
        this.selectArea = ''
        this.addressInfo = {
          id: item.id,
          province: item.province,
          city: item.city,
          area: item.area,
          reciveAddress: item.address,
          reciveName: item.receiveGoodsPerson,
          recivePhone: item.receiveGoodsPhone,
          defaulted: item.defaultAddress
        }
      } else {
        this.selectCity = ''
        this.selectArea = ''
        this.addressInfo = {
          id: '',
          province: '',
          city: '',
          area: '',
          reciveAddress: '',
          reciveName: '',
          recivePhone: '',
          defaulted: false
        }
      }
      this.editAdd = true
    },
    handleClose () {
      this.editAdd = false
      this.addressInfo = null
      this.selectProvince = ''
      this.cityList = null
      this.selectCity = ''
      this.areaList = null
      this.selectArea = ''
      this.area = ''
      this.codeP = ''
      this.codeC = ''
      this.codeA = ''
    },
    handleSaved () {
      const reg = /^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,2,3,5,6,7,8])|(19[8,9]))\d{8}$/
      if (this.addressInfo.reciveAddress === '') {
        this.$message.warning('请输入详细地址信息')
      } else if (this.addressInfo.reciveName === '') {
        this.$message.warning('请输入正确的收货人姓名')
      } else if (this.addressInfo.recivePhone === '') {
        this.$message.warning('手机号码不能为空')
      } else if (!reg.test(this.addressInfo.recivePhone)) {
        this.$message.warning('请输入有效的手机号码')
      } else if (this.addressInfo.reciveAddress.toString().length > 50) {
        this.$message.warning('输入地址长度不能超过50位')
      } else if (this.addressInfo.reciveName.toString().length > 20) {
        this.$message.warning('输入姓名长度不能超过20位')
      } else {
        if (this.addressInfo.id === '') {
          this.$http.post(`${window.SITE_CONFIG['forumURL']}/integral/userorderaddress/save`, {
            address: this.addressInfo.reciveAddress,
            defaultAddress: this.addressInfo.defaulted,
            receiveGoodsPerson: this.addressInfo.reciveName,
            province: this.addressInfo.province,
            city: this.addressInfo.city,
            area: this.addressInfo.area,
            receiveGoodsPhone: this.addressInfo.recivePhone
          })
            .then(data => {
              if (data.data.code === 0) {
                this.$message.success('新增成功')
                this.getAddressList()
                this.handleClose()
                // 更新地址列表
              } else {
                this.$message.error(data.data.msg)
              }
            })
            .catch(() => {
              // this.$message.error(().response.data.message)
            })
        } else {
          this.$http.post(`${window.SITE_CONFIG['forumURL']}/integral/userorderaddress/update`, {
            id: this.addressInfo.id,
            address: this.addressInfo.reciveAddress,
            defaultAddress: this.addressInfo.defaulted,
            receiveGoodsPerson: this.addressInfo.reciveName,
            province: this.addressInfo.province,
            city: this.addressInfo.city,
            area: this.addressInfo.area,
            receiveGoodsPhone: this.addressInfo.recivePhone
          })
            .then(data => {
              if (data.data.code === 0) {
                this.$message.success('地址更新成功')
                this.getAddressList()
                this.handleClose()
                // this.getAddressList()
              } else {
                this.$message.error(data.data.msg)
                // this.handleClose2()
                // this.getAddressList()
              }
            })
            .catch(() => {
              this.$message.error('地址更新失败')
              // this.handleClose2()
              // this.getAddressList()
            })
        }
      }
    },
    handleProvinceChoose (value) {
      this.$forceUpdate()
      this.addressInfo.province = this.selectProvince.slice(0, this.selectProvince.indexOf('%'))
      this.codeP = this.selectProvince.slice(this.selectProvince.indexOf('%') + 1)
      this.selectCity = ''
      this.cityList = null
      this.selectArea = ''
      this.areaList = null
      this.addressInfo.area = ''
      this.addressInfo.city = ''
      this.codeC = ''
      this.codeA = ''
      this.getCity()
    },
    handleCityChoose (value) {
      this.addressInfo.city = this.selectCity.slice(0, this.selectCity.indexOf('%'))
      this.codeC = this.selectCity.slice(this.selectCity.indexOf('%') + 1)
      this.selectArea = ''
      this.areaList = null
      this.addressInfo.area = ''
      this.codeA = ''
      this.getArea()
    },
    handleAreaChoose (value) {
      this.addressInfo.area = this.selectArea.slice(0, this.selectArea.indexOf('%'))
      this.codeA = this.selectArea.slice(this.selectArea.indexOf('%') + 1)
    },
    getProvince () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/integral/sysprovince/provinceList`)
        .then(data => {
          if (data.data.code === 0) {
            this.provinceList = data.data.provinceList
          } else {
            this.$message.error(data.data.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取省份失败')
        })
    },
    getCity () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/integral/sysprovince/cityList/${this.codeP}`)
        .then(data => {
          if (data.data.code === 0) {
            this.cityList = data.data.cityList
          } else {
            this.$message.error(data.data.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取城市失败')
        })
    },
    getArea () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/integral/sysprovince/areaList/${this.codeC}`)
        .then(data => {
          if (data.data.code === 0) {
            this.areaList = data.data.areaList
          } else {
            this.$message.error(data.data.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取区失败')
        })
    },
    changeCouponType (val) {
      this.couponId = ''
    },
    // 生成订单
    createOrder () {
      let temp = []
      if (this.selectAddId) {
        temp = this.addressList.filter(item => {
          return item.id === this.selectAddId
        })
      }
      if (temp.length === 0) {
        temp = this.addressList.filter(item => {
          return item.defaultAddress === true
        })
      }
      if (temp.length === 0) {
        this.$message.error('请选择地址')
        return false
      }
      if (Number(this.usedBalance) > this.userBalance) {
        this.$message.error('使用余额不能超过当前余额')
        return false
      }
      // start
      let actualPrice = this.totalPrice
      if (this.couponType === 1 && this.couponId) {
        let index = this.couponList.findIndex(item => {
          return item.id === this.couponId
        })
        if (index > -1) {
          actualPrice = Math.round((actualPrice - this.couponList[index].amount) * 100) / 100
        }
      } else if (this.couponType === 2 && this.couponMoney) {
        actualPrice = actualPrice - this.couponMoney
      }
      if (actualPrice < 0) {
        actualPrice = 0
        if ((Number(this.usedBalance) || 0) > 0) {
          this.$message.error('请调整输入可用金额,优惠券已满足')
          return false
        }
      } else {
        actualPrice = actualPrice - Number(this.usedBalance)
        if (actualPrice < 0) {
          actualPrice = 0
          this.$message.error('请调整输入可用金额,减少使用余额')
          return false
        }
      }
      // end
      // console.log(temp)
      this.$http.post(`${window.SITE_CONFIG['trainURL']}/pay/trainorders/createOrder`, {
        'discountWay': this.couponType, // 优惠方式 1:优惠卷，2：优惠码
        'discountCode': this.couponType === 2 ? this.couponId : '', // 优惠码
        'couponId': this.couponType === 1 ? this.couponId : '', // 优惠卷id
        'useBalance': this.usedBalance, // 使用余额
        'buyType': this.type, // 购买类型 1、课程；2、电子书；3、购物车；4、实体书；5、证书
        'productId': this.productId || '', // 产品id，这里指的是图书、课程、电子书、购物车、证书等id
        'inviteUserId': '', // 邀请人id
        'count': this.count, // 购买商品总数量
        'phone': temp[0].receiveGoodsPhone, // 联系方式
        'address': temp[0].province + temp[0].city + temp[0].area + temp[0].address, // 收货地址
        'contacts': temp[0].receiveGoodsPerson // 联系人
      })
        .then(data => {
          if (data.data.code === 0) {
            if (data.data.data.payJump) {
              this.submitPay(data.data.data.id)
            } else {
              this.$message.success('订单完成')
              this.$router.go(-1)
            }
          } else {
            this.$message.error(data.data.msg)
          }
        })
    },
    // 支付
    submitPay (id) {
      // returnUrl: location.origin
      // window.location.replace(`${window.SITE_CONFIG['trainURL']}/pay/trainorders/goAlipay?orderId=${id}&userId=${this.$store.state.user.userId}`)
      window.location.href = `${window.SITE_CONFIG['trainURL']}/pay/trainorders/goAlipay?orderId=${id}&userId=${this.$store.state.user.userId}&returnUrl=${location.origin}/personalCenter/myBought`
      // openOther(`    `, true)
    }
  }
}
</script>
<style scoped>
.content {
  margin: 20px auto;
  width: 1190px;
  padding: 40px 142px;
  background: #fff;
}
.page-title {
  font-size: 20px;
  color: #333333;
  font-weight: bold;
}
.address-list {
  margin: 30px 0;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}
.address {
  width: 216px;
  height: 121px;
  background: url("/static/img/add.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 10px 18px;
  font-size: 12px;
  color: #333333;
  /* border */
}
.addressSelect {
  background: url("/static/img/addSelect.png");
}
.address-margin-left {
  margin-left: 16px;
}
.consignee-name {
  width: 100%;
  border-bottom: 1px solid #eee;
  padding: 3px 0 7px;
}
.consignee-add {
  margin-top: 7px;
  line-height: 20px;
  /* height: 40px;
  overflow: hidden; */
}
.addUpdate-button {
  color: #c71d31;
  padding-top: 5px;
}
.button {
  height: 40px;
  padding: 0 43px;
  background: #1d65a8;
  border: none;
  color: #fff;
  cursor: pointer;
  user-select: none;
}
.shop-cart-but {
  background: #fff;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  margin: 0 10px;
}
.shop-cart-but:hover {
  background: #1d65a8;
  color: #fff;
}
.good-name {
  padding-left: 5px;
  text-align: left;
}
.coupon-row {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.money-row {
  margin-top: 30px;
  width: 100%;
  height: 68px;
  line-height: 68px;
  display: flex;
  justify-content: flex-end;
  background-color: #eee;
}
.money-row .money-used {
  display: inline-block;
  font-size: 16px;
  color: #333333;
  margin: 0 50px 0 10px;
}
.money-row .final-money {
  font-size: 20px;
  color: #bf1b22;
}
.pay-row {
  text-align: right;
}
.pay-row .pay-button {
  margin-top: 30px;
  height: 40px;
  line-height: 40px;
}
/* 修改地址 */

.addInfo {
  height: 309px;
  padding: 40px 0;
  border-bottom: 1px solid #eeeeee;
}
.addInfo p {
  margin: 0;
}
.addli {
  height: 36px;
  line-height: 36px;
  display: flex;
  margin-bottom: 30px;
  color: #333333;
  font-size: 14px;
}
.addli p {
  width: 198px;
}
.addli input {
  padding-left: 10px;
}
.addInfo1 p {
  text-indent: 98px;
}
.addInfo2 p {
  text-indent: 98px;
}
.addInfo3 p {
  text-indent: 84px;
}
.addInfo4 p {
  text-indent: 98px;
}
.addInfo1 input {
  width: 436px;
}
.addInfo2 input {
  width: 811px;
}
.addInfo3 input {
  width: 160px;
}
.addInfo4 input {
  width: 160px;
}
.default {
  text-indent: 21px;
}
.saveAdd {
  width: 150px;
  height: 40px;
  background: #1d65a8;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-top: 30px;
  margin-left: 859px;
  cursor: pointer;
  user-select: none;
}
</style>
